import React, { useEffect, useMemo, useState } from "react";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import SearchSessionResult from "./partials/SearchSessionResult";

import {
    getSessionResults  as onGetSessionResults,
    proclamerSession   as onProclamSession,
    getProclamationResults    as onGetProclamationResults,
} from "store/actions";

import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import { Col, Row, Card, CardBody, Button, Badge, Modal, ModalHeader, ModalBody, ModalFooter, Table, Spinner } from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer, toast } from "react-toastify";
import { useParams } from "react-router-dom";

//import ResultatsPharmaciePDF, { generatePDF } from "./partials/ResultatsPharmaciePDF";
import ResultatsPharmaciePDF, { generatePDF } from "./partials/ResultatsPharmaciePDF";
import ProclamationResultsModal from "./partials/ProclamationResultsModal";
import FinalDeliberationManager from "./FinalDeliberationManager"; // 🆕 Import du nouveau composant

const ExamResult = () => {
    document.title = "Liste des résultats de la session | CinzanEdu";

    const dispatch = useDispatch();
    // CORRECTION : Récupération des deux paramètres depuis l'URL
    const { sessionUuid, examUuid } = useParams();

    const [filters,                      setFilters]                      = useState({});
    const [isGeneratingPDF,              setIsGeneratingPDF]              = useState(false);
    const [showProclamationModal,        setShowProclamationModal]        = useState(false);
    const [showProclamationResultsModal, setShowProclamationResultsModal] = useState(false); 
    const [showFinalDelib,               setShowFinalDelib]               = useState(false); // 🆕 State pour basculer la vue
    const [studyLevelName, setStudyLevelName] = useState("");

    const [semesterName, setSemesterName] = useState("");

    // --- Selector ---
    const SessionResultProperties = createSelector(
        (state) => state.sessionReducer,
        (sessionReducer) => ({
            sessionResults:      sessionReducer.sessionResults      || [],
            ueColumns:           sessionReducer.ueColumns           || [],
            sessionInfo:         sessionReducer.sessionInfo         || null,
            isProclaimed:        sessionReducer.isProclaimed        || false,
            isProclaiming:       sessionReducer.isProclaiming       || false,
            proclamationResults: sessionReducer.proclamationResults || [], 
            proclamationStats:   sessionReducer.proclamationStats   || null, 
            loadingProclamation: sessionReducer.loadingProclamation || false, 
            loading:             sessionReducer.loading,
        })
    );

    const {
        sessionResults,
        ueColumns,
        sessionInfo,
        isProclaimed,
        isProclaiming,
        proclamationResults, 
        proclamationStats,   
        loadingProclamation, 
        loading,
    } = useSelector(SessionResultProperties);

    const [isLoading, setLoading] = useState(true);

    console.log("SESSION UUID: ", sessionUuid);
    console.log("EXAM UUID:" , examUuid);

     console.log("PROCLAMATION RESULTS:" , proclamationResults);
    

    // --- Fetch initial CORRIGÉ ---
    useEffect(() => {
        if (sessionUuid) {
            // On envoie systématiquement les deux UUID si disponibles
            dispatch(onGetSessionResults({ 
                session_uuid: sessionUuid,
                exam_uuid: examUuid || "" // On passe l'exam_uuid s'il existe
            }));
        }
    }, [dispatch, sessionUuid, examUuid]);

    // --- Toast proclamation ---
    useEffect(() => {
        if (isProclaimed) {
            setShowProclamationModal(false);
            toast.success("Résultats proclamés avec succès ! Les notes sont verrouillées.");
        }
    }, [isProclaimed]);


    // --- Charger proclamation si déjà proclamé ---
    useEffect(() => {
        if (sessionUuid && examUuid && filters.study_level_id) {
            // AJOUT CONDITION : On lance la recherche si on a un semestre OU si c'est un rattrapage
            if (filters.semester_id || sessionInfo?.type === "Rattrapage") {
                dispatch(onGetProclamationResults({
                    session_uuid:   sessionUuid,
                    exam_uuid:    examUuid, // <--- Indispensable pour le filtre SQL
                    study_level_id: filters.study_level_id,
                    semester_id:    filters.semester_id || "", 
                }));
            }
        }
    }, [sessionUuid, filters.study_level_id, filters.semester_id, sessionInfo?.type, dispatch, examUuid]);

    // --- Search CORRIGÉ ---
    const handleSearch = (newFilters) => {
        setSemesterName(newFilters.semester_label);

        console.log("FILTERS:", newFilters);
        setStudyLevelName(newFilters.study_level_label);

        // CORRECTION : On vide les anciens résultats et colonnes pour le nettoyage visuel
        dispatch(onGetSessionResults({ sessionResults: [], ueColumns: [] }));

        const payload = {
            session_uuid: sessionUuid,
            exam_uuid: examUuid || "", // On conserve le contexte de l'examen pendant le filtre
            ...newFilters,
        };
        setFilters(payload);
        dispatch(onGetSessionResults(payload));
    };

    // --- Stats ---
    const stats = useMemo(() => {
        const total  = sessionResults.length;
        const admis  = sessionResults.filter((r) => r.mention === "Admis").length;
        const ajourn = sessionResults.filter((r) => r.mention === "Ajourné").length;
        return { total, admis, ajourn };
    }, [sessionResults]);

    // --- Proclamation ---
    const handleProclamation = () => {

        console.log("Filtres actuels avant proclamation:", filters);


        if (!filters.study_level_id) {
            toast.warning("Veuillez sélectionner un niveau avant de proclamer.");
            return;
        }

        const payload = {
            session_uuid:   sessionUuid,
            exam_uuid:      examUuid, // 👈 AJOUTE ÇA : C'est la donnée manquante dans ton log
            study_level_id: filters.study_level_id,
            semester_id:    filters.semester_id, 
        };

        console.log("ENVOI PROCLAMATION AVEC EXAM_UUID:", payload);

        /*
        dispatch(onProclamSession({
            session_uuid:   sessionUuid,
            exam_uuid:   examUuid,
            study_level_id: filters.study_level_id,
            semester_id:    filters.semester_id , 
        }));
        */
       dispatch(onProclamSession(payload));
    };

    // 🆕 Voir la proclamation
    const handleViewProclamation = () => {
        dispatch(onGetProclamationResults({
            session_uuid:   sessionUuid,
            exam_uuid:   examUuid,
            study_level_id: filters.study_level_id || "",
            semester_id:    filters.semester_id || "", 
        }));
        setShowProclamationResultsModal(true);
    };

    const isAlreadyProclaimed = isProclaimed || (proclamationResults && proclamationResults.length > 0);    

    // --- Colonnes fixes ---
    const fixedColumns = [
        {
            header: "Matricule",
            accessorKey: "student.student_number",
            enableColumnFilter: false,
            enableSorting: true,
            cell: (cellProps) =>
                cellProps.row.original.student?.student_number ?? "-",
        },
        {
            header: "Nom",
            accessorKey: "student.last_name",
            enableColumnFilter: false,
            enableSorting: true,
            cell: (cellProps) =>
                cellProps.row.original.student?.last_name ?? "-",
        },
        {
            header: "Prénom",
            accessorKey: "student.first_name",
            enableColumnFilter: false,
            enableSorting: true,
            cell: (cellProps) =>
                cellProps.row.original.student?.first_name ?? "-",
        },
        {
            header: "Sexe",
            accessorKey: "student.sex",
            enableColumnFilter: false,
            enableSorting: true,
            cell: (cellProps) =>
                cellProps.row.original.student?.sex ?? "-",
        },
    ];

    // --- Colonnes dynamiques UE ---
    const ueDynamicColumns = useMemo(() => {
        return (ueColumns || []).map((ue) => ({
            header: ue.ue_label,
            accessorKey: `ue_${ue.ue_id}`,
            enableColumnFilter: false,
            enableSorting: true,
            cell: (cellProps) => {
                const notes   = cellProps.row.original.ue_notes || [];
                const found   = notes.find((n) => n.ue_id === ue.ue_id);
                const moyenne = found?.moyenne;

                if (moyenne === null || moyenne === undefined) return "-";

                return (
                    <span style={{
                        color: parseFloat(moyenne) >= 10
                            ? "var(--bs-success)"
                            : "var(--bs-danger)",
                        fontWeight: 500,
                    }}>
                        {parseFloat(moyenne).toFixed(2)}
                    </span>
                );
            },
        }));
    }, [ueColumns]);

    // --- Colonnes Total + Moyenne ---
    const summaryColumns = [
        /*{
            header: "Total",
            accessorKey: "total",
            enableColumnFilter: false,
            enableSorting: true,
            cell: (cellProps) => (
                <strong>{cellProps.row.original.total}</strong>
            ),
        },*/
        {
            header: "Moyenne",
            accessorKey: "moyenne",
            enableColumnFilter: false,
            enableSorting: true,
            cell: (cellProps) => {
                const moy = parseFloat(cellProps.row.original.moyenne);
                return (
                    <Badge color={moy >= 10 ? "success" : "danger"}>
                        {moy.toFixed(2)}/20
                    </Badge>
                );
            },
        },
    ];

    const columns = useMemo(
        () => [...fixedColumns, ...ueDynamicColumns, ...summaryColumns],
        [ueDynamicColumns]
    );

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">

                    <Breadcrumbs
    title="Sessions"
    breadcrumbItem={
        sessionInfo
            ? `Résultats — ${sessionInfo.evaluation_title} · ${sessionInfo.label} · ${sessionInfo.academic_year}`
            : "Résultats de session"
    }
/>

                    {/*<SearchSessionResult onSearch={handleSearch} />*/}
                    <SearchSessionResult onSearch={handleSearch} sessionInfo={sessionInfo} />

                    {loading ? <Spinners setLoading={setLoading} /> :
                        <Row>
                            <Col lg="12">
                                <Card>
                                    <CardBody className="border-bottom d-flex justify-content-between align-items-center flex-wrap gap-2">
                                        <div className="text-muted small">
                                            {sessionResults.length} étudiant(s) trouvé(s)
                                        </div>

                                        <div className="d-flex gap-2">
                                            {sessionInfo?.type === "Rattrapage" && (
                                                <Button
                                                    color={showFinalDelib ? "secondary" : "danger"}
                                                    onClick={() => setShowFinalDelib(!showFinalDelib)}
                                                >
                                                    <i className={showFinalDelib ? "bx bx-list-ul me-1" : "bx bx-gavel me-1"}></i>
                                                    {showFinalDelib ? "Afficher les Notes" : "Décision Finale (Art. 11/12)"}
                                                </Button>
                                            )}

                                             {/* <Button
                                                color="secondary"
                                                outline
                                                onClick={() =>
                                                    generatePDF({
                                                        sessionResults,
                                                        ueColumns,
                                                        sessionInfo,
                                                    })
                                                }
                                            >
                                                📄 Moyennes en PDF
                                            </Button>
                                            */}
                                            

                                            {isAlreadyProclaimed && (
                                                <Button
                                                    color="info"
                                                    outline
                                                    onClick={handleViewProclamation}
                                                >
                                                    Voir la proclamation {semesterName ? `du ${semesterName}` : ""}
                                                    
                                                </Button>
                                            )}

                                            <Button
                                                color={isAlreadyProclaimed ? "success" : "warning"} 
                                                disabled={
                                                    !filters.study_level_id || 
                                                    !sessionResults.length  || 
                                                    isAlreadyProclaimed || 
                                                    loadingProclamation
                                                }
                                                onClick={() => setShowProclamationModal(true)}
                                            >
                                                {loadingProclamation ? (
                                                    <><Spinner size="sm" className="me-1" /> Vérification...</>
                                                ) : isAlreadyProclaimed ? (
                                                    `Résultats proclamés pour ${semesterName ? `(${semesterName})` : ""}`
                                                ) : (
                                                    `Proclamer les résultats ${semesterName || ""}`
                                                )}
                                            </Button>
                                        </div>
                                    </CardBody>

                                    <CardBody>
                                        {showFinalDelib ? (
                                            <FinalDeliberationManager 
                                                sessionResults={sessionResults}
                                                sessionInfo={sessionInfo}
                                                filters={filters}
                                            />
                                        ) : (
                                            <TableContainer
                                                columns={columns}
                                                data={sessionResults || []}
                                                isCustomPageSize={true}
                                                isGlobalFilter={true}
                                                isPagination={true}
                                                SearchPlaceholder="Rechercher un étudiant..."
                                                tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                                                theadClass="table-light"
                                                pagination="pagination"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                            />
                                        )}
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    }
                </div>
            </div>

            <Modal isOpen={showProclamationModal} toggle={() => setShowProclamationModal(false)} centered>
                <ModalHeader toggle={() => setShowProclamationModal(false)}>
                    📣 Confirmation de proclamation
                </ModalHeader>
                <ModalBody>
                    <div className="mb-3 p-3 bg-light rounded border-start border-4 border-info">
                        <div className="fw-bold text-uppercase">{sessionInfo?.label}</div>
                        <div className="text-muted small">Année académique : {sessionInfo?.academic_year}</div>
                    </div>

                    <p className="small text-muted">Synthèse technique pour le <strong>{semesterName}</strong> :</p>
                    
                    <Table bordered size="sm" className="mb-3">
                        <thead className="table-light">
                            <tr>
                                <th>Indicateur</th>
                                <th className="text-center">Valeur</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Étudiants concernés</td>
                                <td className="text-center fw-bold">{sessionResults?.length || 0}</td>
                            </tr>
                            <tr>
                                <td>Semestre ciblé</td>
                                <td className="text-center fw-bold text-primary">{semesterName}</td>
                            </tr>
                            <tr>
                                <td>Action</td>
                                <td className="text-center text-danger small">Calcul UE + Verrouillage</td>
                            </tr>
                        </tbody>
                    </Table>

                    <div className="alert alert-warning mb-0">
                        <i className="bx bx-error-exclamation me-2"></i>
                        Cette action est <strong>irréversible</strong>. Les notes seront verrouillées pour ce semestre.
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button 
                        color="secondary" 
                        outline 
                        onClick={() => setShowProclamationModal(false)} 
                        disabled={isProclaiming}
                    >
                        Annuler
                    </Button>
                    <Button 
                        color="success" 
                        onClick={handleProclamation}
                        disabled={isProclaiming}
                    >
                        {isProclaiming ? (
                            <><Spinner size="sm" className="me-1" /> Proclamation...</>
                        ) : (
                            "Confirmer"
                        )}
                    </Button>
                </ModalFooter>
            </Modal>

            {/* Modal résultats proclamation */}
            <ProclamationResultsModal
                isOpen={showProclamationResultsModal}
                toggle={() => setShowProclamationResultsModal(false)}
                proclamationResults={proclamationResults}
                proclamationStats={proclamationStats}
                sessionInfo={sessionInfo}
                loadingProclamation={loadingProclamation}
                ueColumns={ueColumns}  // ✅ Ajout de cette prop
                studyLevelName={studyLevelName}
            />

            <ToastContainer />
        </React.Fragment>
    );
};

export default ExamResult;